module.exports = __webpack_public_path__ + "static/Fresh-Online-Shopping-bf38e22450878ae31258d05d4209bdb1.jpeg";